import React from 'react';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Unstable_Grid2';
import { Outlet } from 'react-router-dom';
import useStyles from './styles';
import {useTheme} from '@mui/system';

const AuthLayout = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  
  return (
    <Grid container sx={styles.root}>
      <Grid sx={styles.imageWrapper} {...{ lg: 6, xs: 12 }} />
      <Grid sx={styles.formWrapper} {...{ lg: 6, xs: 12 }}>
        <Paper sx={styles.formContent}>
          <Outlet />
        </Paper>
      </Grid>
    </Grid>
  );
};

export default AuthLayout;
